import * as React from 'react';

export class RawDataLandingPageSvg extends React.Component<{}> {

  render() {
    return (
      <svg 
          width="620px" 
          height="227px"
          viewBox="0 0 620 227" 
          version="1.1"
          xmlns="http://www.w3.org/2000/svg" 
          xmlnsXlink="http://www.w3.org/1999/xlink"
      >
        <defs/>
        <g id="export" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g id="Group-9" transform="translate(0.000000, 75.000000)" stroke="#CEE9F3" strokeWidth="2">
            <rect id="Rectangle-3" x="1" y="1" width="15" height="10"/>
            <rect id="Rectangle-3-Copy" x="1" y="28" width="15" height="10"/>
            <rect id="Rectangle-3-Copy" x="1" y="56" width="15" height="10"/>
            <rect id="Rectangle-3" x="1" y="84" width="15" height="10"/>
            <rect id="Rectangle-3-Copy" x="1" y="111" width="15" height="10"/>
            <rect id="Rectangle-3-Copy" x="1" y="139" width="15" height="10"/>
            <rect id="Rectangle-3" x="38" y="1" width="100" height="10"/>
            <rect id="Rectangle-3-Copy" x="38" y="28" width="100" height="10"/>
            <rect id="Rectangle-3-Copy" x="38" y="56" width="100" height="10"/>
            <rect id="Rectangle-3" x="160" y="1" width="100" height="10"/>
            <rect id="Rectangle-3" x="384" y="1" width="150" height="10"/>
            <rect id="Rectangle-3-Copy-18" x="545" y="1" width="72" height="10"/>
            <rect id="Rectangle-3-Copy" x="394" y="28" width="166" height="10"/>
            <rect id="Rectangle-3-Copy-26" x="572" y="28" width="45" height="10"/>
            <rect id="Rectangle-3-Copy-8" x="316" y="83" width="116" height="10"/>
            <rect id="Rectangle-3-Copy-10" x="444" y="83" width="116" height="10"/>
            <rect id="Rectangle-3-Copy-11" x="572" y="83" width="45" height="10"/>
            <rect id="Rectangle-3-Copy-2" x="160" y="28" width="222" height="10"/>
            <rect id="Rectangle-3-Copy-9" x="160" y="83" width="144" height="10"/>
            <rect id="Rectangle-3-Copy-19" x="508" y="137" width="45" height="10"/>
            <rect id="Rectangle-3-Copy-12" x="508" y="110" width="110" height="10"/>
            <rect id="Rectangle-3-Copy-19" x="565" y="137" width="53" height="10"/>
            <rect id="Rectangle-3-Copy-3" x="481" y="55" width="62" height="10"/>
            <rect id="Rectangle-3-Copy-25" x="555" y="56" width="62" height="10"/>
            <rect id="Rectangle-3-Copy-13" x="481" y="110" width="15" height="10"/>
            <rect id="Rectangle-3-Copy-20" x="481" y="137" width="15" height="10"/>
            <rect id="Rectangle-3-Copy-4" x="407" y="55" width="62" height="10"/>
            <rect id="Rectangle-3-Copy-14" x="360" y="110" width="109" height="10"/>
            <rect id="Rectangle-3-Copy-21" x="360" y="137" width="109" height="10"/>
            <rect id="Rectangle-3-Copy-5" x="333" y="55" width="62" height="10"/>
            <rect id="Rectangle-3-Copy-15" x="333" y="110" width="15" height="10"/>
            <rect id="Rectangle-3-Copy-22" x="333" y="137" width="15" height="10"/>
            <rect id="Rectangle-3-Copy-6" x="259" y="55" width="62" height="10"/>
            <rect id="Rectangle-3-Copy-16" x="220" y="110" width="101" height="10"/>
            <rect id="Rectangle-3-Copy-23" x="220" y="137" width="101" height="10"/>
            <rect id="Rectangle-3-Copy-7" x="160" y="55" width="87" height="10"/>
            <rect id="Rectangle-3-Copy-17" x="160" y="110" width="48" height="10"/>
            <rect id="Rectangle-3-Copy-24" x="160" y="137" width="48" height="10"/>
            <rect id="Rectangle-3-Copy" x="38" y="83" width="100" height="10"/>
            <rect id="Rectangle-3-Copy" x="38" y="110" width="100" height="10"/>
            <rect id="Rectangle-3-Copy" x="38" y="138" width="100" height="10"/>
          </g>
          <g id="Group-8" transform="translate(278.000000, 2.000000)">
            <g id="Group-6">
              <polygon 
                  id="Path-6" 
                  fill="#FFFFFF" 
                  points="26.975 42.992126 15.5625 42.992126 0 57.7129013 0 84 83 84 83 57.7129013 67.4375 42.992126"
              />
              <g id="Group" stroke="#CAEDFA" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2">
                <polyline id="Stroke-1371" points="57.2352973 58.1804662 57.2352973 66.3287222 25.7558838 66.3287222 25.7558838 58.1804662"/>
                <polygon
                    id="Stroke-1372"
                    points="82.9911811 83.6292053 0 83.6292053 0 57.6793456 25.7558838 57.6793456 25.7558838 66.3292989
                    57.2352973 66.3292989 57.2352973 57.6793456 82.9911811 57.6793456"
                />
                <polyline id="Stroke-1373" points="0 57.6793456 14.4333111 43.2627569 27.0622795 43.2627569"/>
                <polyline id="Stroke-1374" points="82.9911811 57.6793456 68.55787 43.2627569 59.5375872 43.2627569"/>
                <path d="M42.926473,43.2627569 L42.926473,0.012990698" id="Stroke-1375"/>
                <polyline id="Stroke-1376" points="61.5279446 25.9628504 42.926473 43.2627569 24.3250014 25.9628504"/>
              </g>
            </g>
            <polygon
                id="Path-7"
                fill="#CAEDFA"
                opacity="0.400000006"
                points="0 58 25.6904762 58 25.6904762 66.6666667 57.3095238 66.6666667 57.3095238 58 83 58 83 84 0 84"
            />
          </g>
        </g>
      </svg>
    )
  }
}